// extracted by mini-css-extract-plugin
export default {"header":"NavBar_header__mlI0B","footer":"NavBar_footer__k7WMX"};